"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaAnchorAttachedParagraphProperty = exports.ctaAnchorAttachedParagraphPropertyDefinition = void 0;
exports.ctaAnchorAttachedParagraphPropertyDefinition = {
    view: {
        label: 'Anchor',
        hint: 'Click on a paragraph on the left side to set the anchor.',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'custom',
    multiple: false,
    name: 'cta-anchor-attached-paragraph',
};
const isCtaAnchorAttachedParagraphProperty = (prop) => {
    return prop.name === exports.ctaAnchorAttachedParagraphPropertyDefinition.name;
};
exports.isCtaAnchorAttachedParagraphProperty = isCtaAnchorAttachedParagraphProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLWFuY2hvci1hdHRhY2hlZC1wYXJhZ3JhcGgucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9jdGEtYW5jaG9yLWF0dGFjaGVkLXBhcmFncmFwaC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDRDQUE0QyxHQUFHO0lBQzFELElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxRQUFRO1FBQ2YsSUFBSSxFQUFFLDBEQUEwRDtLQUNqRTtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFFBQVE7SUFDZCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSwrQkFBK0I7Q0FDTixDQUFBO0FBSTFCLE1BQU0sb0NBQW9DLEdBQUcsQ0FBQyxJQUFrQixFQUE4QyxFQUFFO0lBQ3JILE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxvREFBNEMsQ0FBQyxJQUFJLENBQUE7QUFDeEUsQ0FBQyxDQUFBO0FBRlksUUFBQSxvQ0FBb0Msd0NBRWhEIn0=